/* eslint-disable no-case-declarations */
import Toast from 'light-toast';
import {
  APP_EVENTS,
  SOCKET_EVENTS,
  SOCKET_PRIMARY_ROUTE,
  SOCKET_SECONDARY_ROUTE,
  SESSION_STATE,
  ROOM_ID,
  JSON_ERROR_CODE,
  FINAL_EVENT_STATUS,
  CHAT_MODE,
  STATE_MODE,
  PLAYER_STATES,
  CAST,
  EVENT_TYPE,
  CANVAS,
  EVENT_STATUS,
  AUTH_MODE,
  BLOCK_TYPE,
  PLAYLIST_ACTION,
  APP_VIEW,
} from './constants';
import Socket from './utils/socket';
import * as appStore from './store/app';
import { setSessionRef } from './store/app/actions';
import { isSWSupported, noop } from './utils';
import { isOnline } from './utils/internet';
import { decryptStateJson } from './utils/encryption';
import CastSender from './utils/cast-sender';
import CastReceiver from './utils/cast-receiver';
import axios from 'axios';
import * as Utils from './utils/index';

export default class Session {
  constructor(ctrl, store) {
    this.ctrl = ctrl;
    this.store = store;
    this.socketState = SESSION_STATE.NA;
    this.isDocumentVisible = true;
    this.disconnectLambdaService = false;
    this.relativeTimeDiff = 0;
    document.addEventListener('visibilitychange', this.onVisibilityChange.bind(this));
    this.userDisplay = null;
    this.bForce = null;
    this.banner = null;
    this.userConnectedFired = false;
  }
  onVisibilityChange() {
    this.isDocumentVisible = document.visibilityState === 'visible';
    this.store.dispatch(appStore.setDocumentVisibility(this.isDocumentVisible));
  }
  destroy() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }

  startMain(bForce) {
    this.disconnectLambdaService = false;
    const appConfig = this.ctrl.appConfig;
    const connectSocket = (onFailure, switchToBackupSocket = false, ms = 3000) => {
      this.connectSocket({
        bForce,
        switchToBackupSocket,
        onFailure,
        ms,
      });
    };
    if (appConfig.drMode) {
      connectSocket(() => {
        // this.connectLambda(bForce);
      }, true);
    } else {
      connectSocket(() => {
        connectSocket(
          () => {
            // this.connectLambda(bForce);
          },
          true,
          10000,
        );
      });
    }
  }
  start(bForce = false) {
    const { castReceiverId } = this.store.getState().app.apiKeyJson.info;
    const appConfig = this.ctrl.appConfig;
    this.startMain(bForce);
    if (appConfig.cast && !this.castSender) {
      this.castSender = new CastSender(this.ctrl, {
        namespace: CAST.NAMESPACE,
        receiverAppId: castReceiverId ? castReceiverId : CAST.RECEIVER_ID,
      });
    }
    if (appConfig.castMode && !this.castReceiver) {
      this.castReceiver = new CastReceiver(this.ctrl, {
        namespace: CAST.NAMESPACE,
        senderId: this.ctrl.appConfig.senderId,
      });
    }
  }
  onReject(socket) {
    if (socket) {
      this.socketState = SESSION_STATE.REJECTED;
      socket.disconnect();
    }
    this.store.dispatch(appStore.setLiveSdkLoaded(false));
    this.store.dispatch(appStore.setSessionState(SESSION_STATE.REJECTED));
    this.ctrl.emit(APP_EVENTS.SESSION_REJECTED);
    this.store.dispatch(appStore.setAppView());
  }
  async handleAliveData(data) {
    const { code, blocked } = data;
    if (code === JSON_ERROR_CODE.REJECTED) {
      this.onReject();
      return;
    }
    if (code === JSON_ERROR_CODE.INVALID_JWT || code === JSON_ERROR_CODE.SERVER_ERROR) {
      this.store.dispatch(appStore.setAppError({ msg: 'Something went wrong, please try again later.' }));
      return;
    }

    this.handleBlockUser(blocked);
    this.store.dispatch(appStore.updateAudCount(data.ac));

    this.aliveTimeout = setTimeout(() => {
      this.startIAmAlive();
    }, 5000);
  }
  async startIAmAlive() {
    if (this.disconnectLambdaService) return;
    const appConfig = this.ctrl.appConfig;
    const { eventId, jwt } = appConfig;
    const { app } = this.store.getState();
    const { eventStatus, sessionExpired, playerState } = app;
    if (sessionExpired) return;
    let localStoredSid;
    try {
      localStoredSid = sessionStorage.getItem(`auth_${eventId}`);
    } catch (err) {
      localStoredSid = null;
    }
    if (appConfig.sid) {
      localStoredSid = appConfig.sid;
    }
    if (eventStatus === FINAL_EVENT_STATUS.ENDED) {
      return;
    }
    clearTimeout(this.aliveTimeout);
    const { actBackup } = this.store.getState().app.apiKeyJson.apis;
    const apiUrl = `https://${actBackup}/alive?evtid=${eventId}&jwt=${jwt}${
      localStoredSid ? '&sid=' + localStoredSid : ''
    }${playerState === PLAYER_STATES.STARTED ? '&playing=true' : '&playing=false'}`;
    try {
      const fResponse = await fetch(apiUrl);
      const data = await fResponse.json();
      this.handleAliveData(data);
    } catch (err) {
      console.error('I am alive api', err);
    }
  }
  checkSWSupport(welcomeData) {
    if (welcomeData.meta.enc && welcomeData.meta.enc.mode === 2) {
      const store = this.store.getState();
      const skipSW = store.app.config.skipSW;
      const swSupported = isSWSupported();
      if (!swSupported && !skipSW) {
        this.store.dispatch(appStore.setAppError({ msg: 'This browser is not supported at the moment.' }));
        if (this.socket) {
          this.socket.disconnect();
        }
        return false;
      }
    }
    return true;
  }
  async startJsonPooling() {
    if (this.disconnectLambdaService) return;
    clearTimeout(this.jsonTimeout);
    const { app } = this.store.getState();
    const { blocked, sessionExpired } = app;
    if (blocked) return;
    if (sessionExpired) return;
    const appConfig = this.ctrl.appConfig;
    const { eventId } = appConfig;
    const url = `https://cleolive.akamaized.net/chatengine/${eventId.substr(2, 2)}/${eventId.substr(
      4,
      2,
    )}/${eventId}/state.json`;
    let data;
    try {
      const fetchResponse = await fetch(url);
      const textResponse = await fetchResponse.arrayBuffer();
      const { app } = this.store.getState();
      const {
        welcomeData: { meta },
      } = app;
      const decryptedResponse = await decryptStateJson(eventId, meta.enc, new Uint8Array(textResponse));
      if (decryptedResponse) {
        data = decryptedResponse;
      }
    } catch (err) {
      data = null;
      console.error('JSON pooling', err);
    }

    if (data) {
      const { app } = this.store.getState();
      const {
        config: { stateMode, chatMode },
        chatDomLoaded,
      } = app;
      if (stateMode === STATE_MODE.CDN_ONLY) {
        const { state, reactions } = data;
        if (state) {
          if (JSON.stringify(state) !== JSON.stringify(this.lastState)) {
            this.lastState = state;
            this.onStateUpdate(state);
          }
        }
        if (JSON.stringify(reactions) !== JSON.stringify(this.reactions)) {
          this.reactions = reactions;
          this.store.dispatch(appStore.updateReactions(reactions));
        }
      }
      if (stateMode === STATE_MODE.CDN_ONLY) {
        const { screenshots } = data;
        var ss = [];
        var deletedSS = [];
        if (screenshots) {
          for (var i = 0; i < screenshots.length; i++) {
            if (screenshots[i].archived) {
              deletedSS.push(screenshots[i]);
            } else {
              ss.push(screenshots[i]);
            }
          }
          this.ctrl.emit(APP_EVENTS.SS_RECEIVED, {
            ss: ss,
            deletedSS: deletedSS,
          });
        }
      }
      if (chatMode === CHAT_MODE.CDN_ONLY) {
        const {
          messages: { messages, currentpage, deletedmsg },
          pinnedmsg,
        } = data;

        if (messages.length && messages.length !== this.lastMessagesLength && chatDomLoaded) {
          this.lastMessagesLength = messages.length;
          this.ctrl.emit(APP_EVENTS.NEW_COMMENTS_RECEIVED, {
            currentPage: currentpage,
            messages,
            deleted: deletedmsg,
          });
        }
        if (deletedmsg && deletedmsg.length && deletedmsg.length !== this.lastDeleteMessageLength && chatDomLoaded) {
          this.lastDeleteMessageLength = deletedmsg.length;
          this.ctrl.emit(APP_EVENTS.COMMENTS_DELETED, {
            deleted: deletedmsg,
          });
        }
        if (JSON.stringify(pinnedmsg) !== JSON.stringify(this.pinnedmsg)) {
          this.pinnedmsg = pinnedmsg;
          this.store.dispatch(appStore.setPinnedMsg(pinnedmsg));
        }
      }
    }
    this.jsonTimeout = setTimeout(() => {
      this.startJsonPooling();
    }, 2000);
  }
  handleBlockUser(blockedType, eventType) {
    if (eventType === EVENT_TYPE.WB_LIVE && blockedType) {
      if (this.socket) {
        this.socket.disconnect();
      }
      this.store.dispatch(appStore.setUserBlocked(blockedType));
      this.store.dispatch(appStore.setAppError({ msg: 'You are blocked from this session!' }));
      return false;
    }
    if (blockedType === BLOCK_TYPE.LINK) {
      this.store.dispatch(
        appStore.setAppError({
          msg: (
            <>
              <p>You have been removed from the show</p>
              <p style={{ fontSize: '20px' }}>Please contact slike.care@timesintenet.in</p>
            </>
          ),
        }),
      );
      return false;
    }
    this.store.dispatch(appStore.setUserBlocked(blockedType));
    return true;
  }
  onJsonWelcome(jsonData) {
    const { sid, code } = jsonData;
    if (code === JSON_ERROR_CODE.SERVER_ERROR || code === JSON_ERROR_CODE.BAD_REQUEST) {
      this.store.dispatch(appStore.setAppError({ msg: 'Something went wrong, please try again later.' }));
      return;
    }
    if (code === JSON_ERROR_CODE.NOT_FOUND) {
      this.store.dispatch(appStore.setAppError({ msg: 'Event not found.' }));
      return;
    }
    if (code === JSON_ERROR_CODE.INVALID_JWT) {
      this.store.dispatch(
        appStore.setAppError({ msg: 'Not authorized, invalid authentication token passed.', act: 'jwt' }),
      );
      return;
    }
    if (jsonData.blocked && jsonData.etype === EVENT_TYPE.WB_LIVE) {
      this.handleBlockUser(jsonData.blocked, jsonData.etype);
      return;
    }
    this.handleBlockUser(jsonData.blocked, jsonData.etype);
    if (code === JSON_ERROR_CODE.OK || code === JSON_ERROR_CODE.REJECTED) {
      if (this.checkSWSupport(jsonData)) {
        this.store.dispatch(appStore.setSessionState(SESSION_STATE.CONNECTED));
        const appConfig = this.ctrl.appConfig;
        const { eventId } = appConfig;
        if (typeof sid !== 'undefined') {
          try {
            sessionStorage.setItem(`auth_${eventId}`, sid);
          } catch (err) {
            console.log(err);
          }
        }
        this.ctrl.emit(APP_EVENTS.SESSION_CONNECTED, jsonData);
        setSessionRef(this);
        if (jsonData.state) {
          this.lastState = jsonData.state;
        }
        const {
          app: { welcomeData, view },
        } = this.store.getState();
        if (!welcomeData) {
          this.store.dispatch(appStore.setWelcomeData(jsonData));
          this.store.dispatch(appStore.addMultipleItemsToCanvas(jsonData.studio));
        }
        if (!view) {
          this.store.dispatch(appStore.setAppView());
        }
        this.store.dispatch(appStore.enableDRMode());
        if (code === JSON_ERROR_CODE.REJECTED) {
          this.onReject();
        } else {
          this.startIAmAlive();
          const { app } = this.store.getState();
          const {
            config: { chatMode, stateMode },
          } = app;
          if (chatMode === CHAT_MODE.CDN_ONLY || stateMode === STATE_MODE.CDN_ONLY) {
            this.startJsonPooling(jsonData);
          }
        }
      }
    } else {
      this.store.dispatch(appStore.setAppError({ msg: 'Something went wrong, please try again later.' }));
    }
  }
  onSocketWelcome(socket, jsonData) {
    this.socket = socket;
    const { sid } = jsonData;
    const appConfig = this.ctrl.appConfig;
    const { eventId } = appConfig;
    if (typeof sid !== 'undefined') {
      try {
        sessionStorage.setItem(`act_${eventId}`, sid);
      } catch (err) {
        console.log(err);
      }
    }
    if (jsonData.blocked) {
      var proceed = this.handleBlockUser(jsonData.blocked, jsonData.etype); // todo
      if (!proceed) {
        this.store.dispatch(appStore.setPoster(jsonData));
        return;
      }
    }
    if (this.checkSWSupport(jsonData)) {
      this.ctrl.emit(APP_EVENTS.SESSION_CONNECTED, jsonData);
      if (!this.userConnectedFired) {
        this.ctrl.emit(APP_EVENTS.USER_CONNECTED, jsonData);
        this.userConnectedFired = true;
      }
      setSessionRef(this);
      this.store.dispatch(appStore.setWelcomeData(jsonData));

      //fetch playlist data if simulive event
      if (jsonData.etype === EVENT_TYPE.SIMULIVE && jsonData?.state?.Status < EVENT_STATUS.EVENT_ENDING) {
        this.fetchPlaylistData();
      }
      if (jsonData.banner) {
        this.bannerChange({ ...jsonData.banner });
      }
      if (jsonData.lband) {
        this.lbandChange({ ...jsonData.lband });
      }
      this.store.dispatch(appStore.addMultipleItemsToCanvas(jsonData.studio));
      this.store.dispatch(appStore.setAppView());
      const { app } = this.store.getState();
      const {
        config: { chatMode, stateMode },
      } = app;
      if (chatMode === CHAT_MODE.CDN_ONLY || stateMode === CHAT_MODE.CDN_ONLY) {
        this.startJsonPooling(jsonData);
      }
    }
    // if (jsonData?.state?.Status === EVENT_STATUS.EVENT_ENDED) {
    //   this.destroy();
    // }
  }
  onStateUpdate(jsonData) {
    this.ctrl.emit(APP_EVENTS.STATE_UPDATE, jsonData);
    this.store.dispatch(appStore.setStateUpdate(jsonData));
    if (jsonData?.Status === EVENT_STATUS.EVENT_ENDED) {
      this.destroy();
    }
    this.store.dispatch(appStore.setAppView());
  }
  onAudCountUpdate(jsonData) {
    this.store.dispatch(appStore.updateAudCount(jsonData.active_users));
  }
  onReactionsUpdate(jsonData) {
    this.store.dispatch(appStore.updateReactions(jsonData));
  }
  onRecordingUpdate(jsonData) {
    if (jsonData && jsonData.length) {
      this.store.dispatch(appStore.setRecordings(jsonData));
    }
  }
  onAdminScreenshotCapture(jsonData) {
    const { welcomeSS } = this.store.getState().app;
    if (welcomeSS) {
      this.store.dispatch(appStore.toggleWelcomeSS());
    }
    this.store.dispatch(appStore.addScreenShot(jsonData));
    this.store.dispatch(appStore.setAppView());
  }
  onAdminScreenshotDelete(ssid) {
    this.store.dispatch(appStore.deleteScreenShot(ssid));
    this.store.dispatch(appStore.setAppView());
  }
  onAdminScreenshotList(jsonData) {
    this.store.dispatch(appStore.setScreenshotList(jsonData));
  }
  onMetaUpdate = (jsonData) => {
    this.store.dispatch(appStore.updateMeta(jsonData));
  };
  async connectLambda(bForce) {
    const appConfig = this.ctrl.appConfig;
    const { eventId, jwt, castMode } = appConfig;
    this.ctrl.appConfig.drMode = true;
    let localStoredSid;
    try {
      localStoredSid = sessionStorage.getItem(`auth_${eventId}`);
    } catch (err) {
      localStoredSid = null;
    }
    if (appConfig.sid) {
      localStoredSid = appConfig.sid;
    }
    const { actBackup } = this.store.getState().app.apiKeyJson.apis;
    const apiUrl = `https://${actBackup}/dr?evtid=${eventId}&jwt=${jwt}${bForce ? '&force=true' : ''}${
      localStoredSid ? '&sid=' + localStoredSid : ''
    }${castMode ? '&cast=true' : ''}`;
    try {
      const fResponse = await fetch(apiUrl);
      const data = await fResponse.json();
      this.onJsonWelcome(data);
    } catch (err) {
      console.error('connect lambda', err);
      setTimeout(() => {
        this.connectLambda(bForce);
      }, 2000);
    }
  }
  onSessionExpire() {
    this.destroy();
    this.store.dispatch(appStore.setSessionExpired());
    this.store.dispatch(appStore.setSessionState(SESSION_STATE.CLOSED));
  }
  connectSocket({ bForce = false, switchToBackupSocket = false, onFailure = noop, ms = 3000 }) {
    let socket;
    let onFailureCalled = false;
    let failureCounter = 0;
    const timeout = setTimeout(() => {
      if (!onFailureCalled) {
        onFailureCalled = true;
        socket.disconnect();
        onFailure();
      }
    }, ms);
    this.socketState = SESSION_STATE.CONNECTING;
    this.store.dispatch(appStore.setSessionState(this.socketState));
    const appConfig = this.store.getState().app.config;
    const { eventId, jwt, jwtData, castMode } = appConfig;
    let localStoredSid;
    try {
      localStoredSid = sessionStorage.getItem(`act_${eventId}`);
    } catch (err) {
      localStoredSid = null;
    }
    if (appConfig.sid) {
      localStoredSid = appConfig.sid;
    }
    const { actPrimary, actBackup } = this.store.getState().app.apiKeyJson.apis;
    let socketDomain = actPrimary;
    if (switchToBackupSocket && actBackup) {
      socketDomain = actBackup;
    }
    const socketUrl = `wss://${socketDomain}/socket?evtid=${eventId}&jwt=${jwt}${bForce ? '&force=true' : ''}${
      localStoredSid ? '&sid=' + localStoredSid : ''
    }${castMode ? '&cast=true' : ''}`;
    socket = new Socket(socketUrl, true, this.ctrl);
    socket.on(SOCKET_EVENTS.MESSAGE, (data) => {
      if (!data) return;
      if (data === 'event ended' && this.socket) {
        this.socket.disconnect();
      }
      const { eventType } = this.store.getState().app;
      const primaryRoute = data.substring(0, 1);
      const secondaryRoute = data.substring(1, 4);
      switch (primaryRoute) {
        case SOCKET_PRIMARY_ROUTE.CONTROL:
          switch (secondaryRoute) {
            case SOCKET_SECONDARY_ROUTE.PONG:
              this.socket?.send(SOCKET_SECONDARY_ROUTE.PING);
              break;
            case SOCKET_SECONDARY_ROUTE.REJECTED:
            case SOCKET_SECONDARY_ROUTE.FORCE_REJECTED:
              this.onReject(socket);
              break;
            case SOCKET_SECONDARY_ROUTE.WELCOME:
              const jsonData = JSON.parse(data.substring(4, data.length));
              this.onSocketWelcome(socket, jsonData);
              break;
            case SOCKET_SECONDARY_ROUTE.STATE_UPDATE:
              const { app } = this.store.getState();
              const {
                config: { stateMode },
              } = app;
              if (stateMode === STATE_MODE.SOCKET_ONLY) {
                this.onStateUpdate(JSON.parse(data.substring(4, data.length)));
              }
              break;
            case SOCKET_SECONDARY_ROUTE.RECORDINGS:
              this.onRecordingUpdate(JSON.parse(data.substring(4, data.length)));
              break;
            case SOCKET_SECONDARY_ROUTE.ADMINSCREENSHOT_ADDED:
              if (data.substring(4, 5) === '1') {
                this.onAdminScreenshotCapture(JSON.parse(data.substring(5, data.length)));
              }
              if (data.substring(4, 5) === '2') {
                this.onAdminScreenshotDelete(data.substring(5, data.length));
              }
              if (data.substring(4, 5) === '3' && data.substring(5, data.length) !== 'null') {
                this.onAdminScreenshotList(JSON.parse(data.substring(5, data.length)));
              }
              break;
            case SOCKET_SECONDARY_ROUTE.CANVAS_ROUTE:
              const jsondata = data.substring(4, data.length);
              this.OnHandleCanvas(jsondata);
              break;
            case SOCKET_SECONDARY_ROUTE.META_UPDATE:
              this.onMetaUpdate(JSON.parse(data.substring(4, data.length)));
              break;
            case SOCKET_SECONDARY_ROUTE.BANNER:
              this.bannerChange({ ...JSON.parse(data.substring(4, data.length)) });
              break;
            case SOCKET_SECONDARY_ROUTE.L_BAND:
              this.lbandChange({ ...JSON.parse(data.substring(4, data.length)) });
              break;

            default:
              break;
          }
          break;
        case SOCKET_PRIMARY_ROUTE.COMM:
          switch (secondaryRoute) {
            case SOCKET_SECONDARY_ROUTE.AUD_COUNT:
              const roomId = data.substring(4, 7);
              if (roomId === ROOM_ID.COMMENTS) {
                const jsonData = JSON.parse(data.substring(7, data.length));
                this.onAudCountUpdate(jsonData);
              }
              break;
            case SOCKET_SECONDARY_ROUTE.GET_PLAYLIST:
              this.handlePlayListDetails(JSON.parse(data.substring(4, data.length)));
              break;
            case SOCKET_SECONDARY_ROUTE.UPDATE_PLAYLIST:
              this.handlePlayListUpdate(JSON.parse(data.substring(4, data.length)));
              break;
            default:
              break;
          }
          break;
        case SOCKET_PRIMARY_ROUTE.OPERATION:
          switch (secondaryRoute) {
            case SOCKET_SECONDARY_ROUTE.USER_BLOCKED:
              const jsonData = JSON.parse(data.substring(4));
              if (jsonData.id === jwtData.userID) {
                this.handleBlockUser(jsonData.type, eventType); // todo
              }
              break;
            case SOCKET_SECONDARY_ROUTE.USER_UNBLOCK:
              const userId1 = data.substring(4);
              if (userId1 === jwtData.userID && eventType !== EVENT_TYPE.WB_LIVE) {
                this.handleBlockUser(false, eventType);
              }
              break;
            case SOCKET_SECONDARY_ROUTE.USER_DISCONNECT:
              const store = this.store.getState();
              if (!store.app.sessionExpired && store.app.limitedViewing) {
                this.onSessionExpire();
              }
              break;
            case SOCKET_SECONDARY_ROUTE.AV_TOKEN:
              console.warn('thisss', this.userDisplay, this.bForce, data);
              const avToken = data.substring(4);
              this.store.dispatch(appStore.setAVToken(avToken));
              this.store.dispatch(appStore.proceedClick({ displayName: this.userDisplay, bForce: this.bForce }));
              this.userDisplay = null;
              this.bForce = null;
              if (this.bForce) {
                this.start(true);
              }
              break;
            default:
              break;
          }
          break;
        default:
          break;
      }
    });
    socket.on(SOCKET_EVENTS.CLOSE, () => {
      const store = this.store.getState();
      if (store.app.sessionExpired) {
        console.log('SESSION EXPIRED');
        return;
      }
      console.log('SOCKET CLOSED');
      this.socket = null;
      if (this.isDocumentVisible) {
        failureCounter++;
      }
      if (failureCounter > 2 && !onFailureCalled && this.isDocumentVisible && !store.app.networkError) {
        onFailureCalled = true;
        socket.disconnect();
        onFailure();
        return;
      }
      if (this.socketState !== SESSION_STATE.ERROR && this.socketState !== SESSION_STATE.REJECTED) {
        this.ctrl.emit(APP_EVENTS.SESSION_CLOSED);
      }
      this.socketState = SESSION_STATE.CLOSED;
      if (store.app.sessionState !== SESSION_STATE.REJECTED && store.app.sessionState !== SESSION_STATE.CLOSED) {
        this.store.dispatch(appStore.setSessionState(this.socketState));
      }
      if (store.app.networkError) {
        return;
      }
      isOnline((status) => {
        if (!status) {
          this.store.dispatch(appStore.setNetworkError(true));
          this.store.dispatch(appStore.setPlayerVisibility(false));
          Toast.loading('Unable to connect to internet');
        }
      });
    });
    socket.on(SOCKET_EVENTS.OPEN, () => {
      failureCounter = 0;
      clearTimeout(timeout);
      this.socketState = SESSION_STATE.CONNECTED;
      this.store.dispatch(appStore.setSessionState(this.socketState));
      const store = this.store.getState();
      if (store.app.networkError && store.app.config.ptype !== 'rtc') {
        this.store.dispatch(appStore.setNetworkError(false));
        this.store.dispatch(appStore.setPlayerVisibility(true));
        Toast.hide();
      }
    });
  }

  bannerChange(data) {
    this.store.dispatch(appStore.setBanner(data));
    // this.store.dispatch(appStore.addBanner(data));
  }

  lbandChange(data) {
    this.store.dispatch(appStore.setLband(data));
  }

  OnHandleCanvas(data) {
    const appConfig = this.store.getState().app.config;
    const { jwtData } = appConfig;

    const payload = JSON.parse(data.substring(1, data.length));

    const operation = data.substring(0, 1);
    switch (operation) {
      case CANVAS.ADD_ITEM:
        this.store.dispatch(appStore.addItemToCanvas(payload));
        window.dispatchEvent(new CustomEvent('CANVAS_UPDATE', { detail: { op: 'add', payload } }));
        // if (type === 'caption') {
        //   pay = { action: 1, aston_id: payload.id, duration: -1, id: payload.id, name: payload.id, repeatCount: null, timestamp: Date.now(), type: 'text', url: payload.heading };
        //   //this.store.dispatch(appStore.setBanner(pay));
        // }
        if (payload.id === jwtData.userID) {
          this.store.dispatch(appStore.setCanvasLiveState(true));
        }
        break;
      case CANVAS.REMOVE_ITEM:
        this.store.dispatch(appStore.removeFromCanvas({ id: payload.id, type: payload?.type }));
        window.dispatchEvent(new CustomEvent('CANVAS_UPDATE', { detail: { op: 'remove', payload } }));
        // if (type !== 'caption') {
        //   pay = { action: 0, id: payload.id, timestamp: payload.id };
        //   // this.store.dispatch(appStore.setBanner(pay));
        // }

        if (payload.id === jwtData.userID) {
          this.store.dispatch(appStore.setCanvasLiveState(false));
        }
        break;
      default:
        break;
    }
  }
  onPlaybackStarted() {
    this.startIAmAlive();
  }
  switchToDr() {
    if (this.socket) {
      this.socket.disconnect();
    }
    this.connectLambda();
  }
  stop() {
    if (this.socket) {
      this.socket.disconnect();
    }
    const store = this.store.getState();
    if (store.app.DRMode) {
      this.disconnectLambdaService = true;
    }
  }

  async handleUserAuth(googleToken = '') {
    const { actPrimary } = this.store.getState().app.apiKeyJson.apis;
    const appConfig = this.store.getState().app.config;
    const { eventId } = appConfig;
    let jwt = appConfig.jwt;
    let payload = {
      event: eventId,
    };
    if (appConfig.public) {
      try {
        jwt = localStorage.getItem(`jwt_${eventId}`);
      } catch (err) {
        console.error('failed to fetch jwt');
      }
    }
    if (typeof jwt !== 'undefined' && jwt !== '' && jwt !== null) {
      payload = { ...payload, jwt: jwt };
    }
    if (typeof googleToken !== 'undefined' && googleToken !== '') {
      payload = { ...payload, token: googleToken };
    }
    let localStoredSid;
    try {
      localStoredSid = sessionStorage.getItem(`act_${eventId}`);
    } catch (err) {
      localStoredSid = null;
    }
    const url = `https://${actPrimary}/auth${localStoredSid ? '?sid=' + localStoredSid : ''}`;
    try {
      const axiosResponse = await axios.post(url, payload);
      const {
        data: { data, code },
      } = axiosResponse;
      if (code !== 200) {
        console.error('failed to authenticate user');
        this.store.dispatch(appStore.setAppError({ msg: 'failed to login' }));
        return;
      }
      if (data.ts) this.relativeTimeDiff = Date.now() - data.ts; // client time diff wrt server
      if (typeof data.sid !== 'undefined') {
        try {
          sessionStorage.setItem(`act_${eventId}`, data.sid);
        } catch (err) {
          console.log(err);
        }
      }
      switch (data.meta?.authmode) {
        case AUTH_MODE.NONE:
          this.handleNonSecureEvent(data);
          break;
        case AUTH_MODE.JWT:
          this.handleJwtSecureEvent(data);
          break;
        case AUTH_MODE.EMAIL:
          this.handleEmailSecureEvent(data);
          break;
        default:
          this.store.dispatch(appStore.setAppError({ msg: 'failed to login , invalid auth mode' }));
          break;
      }
    } catch (err) {
      this.store.dispatch(appStore.setAppError({ msg: 'failed to login' }));
      console.error('failed to authenticate user');
    }
  }

  handleJwtSecureEvent(data) {
    const appConfig = this.store.getState().app.config;
    let playRecording = false;
    if ('recording' in data) {
      playRecording =
        data.recording?.RecID !== data.state?.ID
          ? true
          : appConfig.dvr
          ? true
          : appConfig.vod !== null
          ? appConfig.vod
          : data.meta.vod;
      const payload = {
        jwt: data.token,
        jwtData: data.token ? Utils.parseJwt(data.token) : {},
        recData: data.recording,
        eventId: data.recording.StreamID,
        isRecording: playRecording,
      };
      this.store.dispatch(appStore.resetAppConfig(payload));
    }
    this.handleEventView(playRecording, data);
  }
  handleEmailSecureEvent(data) {
    if (!data) return;
    const appConfig = this.store.getState().app.config;
    let payload;
    if (appConfig.public) {
      if (typeof data?.token === 'undefined' || data?.token === '') {
        this.store.dispatch(appStore.setWelcomeData(data));
        this.store.dispatch(appStore.addMultipleItemsToCanvas(data.studio));
        this.store.dispatch(appStore.setGoogleLoginRequired(true));
        return;
      }
      try {
        localStorage.setItem(`jwt_${data.state.ID}`, data.token);
      } catch (err) {
        console.log(err);
      }
      this.store.dispatch(appStore.setGoogleLoginRequired(false));
    }
    payload = { jwt: data.token, jwtData: data.token ? Utils.parseJwt(data.token) : {} };
    let playRecording = false;
    if ('recording' in data) {
      playRecording =
        data.recording?.RecID !== data.state?.ID
          ? true
          : appConfig.dvr
          ? true
          : appConfig.vod !== null
          ? appConfig.vod
          : data.meta.vod;
      payload = { ...payload, recData: data.recording, eventId: data.recording.StreamID, isRecording: playRecording };
    }
    this.store.dispatch(appStore.resetAppConfig(payload));
    this.handleEventView(playRecording, data);
  }

  handleNonSecureEvent(data) {
    const appConfig = this.store.getState().app.config;
    let payload;
    if (appConfig.public) {
      if (typeof data.token === 'undefined' || data.token === '') {
        this.store.dispatch(appStore.setAppError({ msg: 'Invalid JWT' }));
        return;
      }
      try {
        localStorage.setItem(`jwt_${data.state.ID}`, data.token);
      } catch (err) {
        console.log(err);
      }
      // payload = { ...payload, skipForm: data.state.Status > EVENT_STATUS.EVENT_RUNNING };
    }
    payload = { ...payload, jwt: data.token, jwtData: data.token ? Utils.parseJwt(data.token) : {} };
    let playRecording = false;
    if ('recording' in data) {
      playRecording =
        data.recording?.RecID !== data.state?.ID
          ? true
          : appConfig.dvr
          ? true
          : appConfig.vod !== null
          ? appConfig.vod
          : data.meta.vod;
      payload = { ...payload, recData: data.recording, eventId: data.recording.StreamID, isRecording: playRecording };
    }
    this.store.dispatch(appStore.resetAppConfig(payload));
    this.handleEventView(playRecording, data);
  }

  handleEventView(playRecording, data) {
    this.store.dispatch(appStore.setSSAdminData(data.ss));
    if (playRecording || data.state.Status < EVENT_STATUS.EVENT_ENDING) this.start();
    else {
      this.store.dispatch(appStore.setWelcomeData(data));
      this.store.dispatch(appStore.addMultipleItemsToCanvas(data.studio));
      this.store.dispatch(appStore.setAppView());
    }
  }

  async fetchMasterJson(backup) {
    const appConfig = this.store.getState().app.config;
    const { eventId } = appConfig;
    const { actPrimary } = this.store.getState().app.apiKeyJson.apis;
    const url = `https://${actPrimary}/master?id=${eventId}${backup ? '&backup=true' : ''}`;
    try {
      const fResponse = await fetch(url);
      const data = await fResponse.json();
      if (data.code === 200) {
        return data.data;
      }
    } catch (err) {
      console.error('failed to fetch master json', err);
    }
    return null;
  }

  async switchToVod() {
    this.destroy();
    const { actPrimary } = this.store.getState().app.apiKeyJson.apis;
    const appConfig = this.store.getState().app.config;
    const { eventId, jwt } = appConfig;
    let localStoredSid;
    try {
      localStoredSid = sessionStorage.getItem(`act_${eventId}`);
    } catch (err) {
      localStoredSid = null;
    }
    const url = `https://${actPrimary}/auth${localStoredSid ? '?sid=' + localStoredSid : ''}`;
    try {
      const axiosResponse = await axios.post(url, {
        event: eventId,
        jwt: jwt,
      });
      const {
        data: { data, code },
      } = axiosResponse;
      if (code !== 200) {
        this.store.dispatch(appStore.setAppError({ msg: 'failed to  to switch to vod' }));
        return;
      }
      if (data.ts) this.relativeTimeDiff = Date.now() - data.ts; // client time diff wrt server
      if ('recording' in data) {
        const payload = {
          jwt: data.token,
          jwtData: data.token ? Utils.parseJwt(data.token) : {},
          recData: data.recording,
          eventId: data.recording.StreamID,
          isRecording: true,
        };
        this.store.dispatch(appStore.resetAppConfig(payload));
        this.handleEventView(true, data);
      } else {
        setTimeout(() => {
          this.switchToVod();
        }, 5000);
      }
    } catch (err) {
      this.store.dispatch(appStore.setAppError({ msg: 'failed to switch to vod' }));
    }
  }

  sendPlayerAnalytics(sendData) {
    try {
      this.socket.send(
        SOCKET_PRIMARY_ROUTE.ANALYTICS + SOCKET_SECONDARY_ROUTE.PLAYER_ANALYTICS + JSON.stringify(sendData),
      );
    } catch (err) {
      console.error('failed to broadcast analytics');
    }
  }

  fetchPlaylistData() {
    this.socket.send(SOCKET_PRIMARY_ROUTE.COMM + SOCKET_SECONDARY_ROUTE.GET_PLAYLIST);
  }

  handlePlayListDetails(data) {
    let pData = {
      head: data.head, // current running index of playlist
      order: data.order, //complete order of the playlist
      ts: data.ts, // last updated playlist ts
    };
    let items = {};
    Object.keys(data.items).forEach((id) => {
      const media = data.items[id];
      items[id] = { hls: Utils.PrepareSimuliveUrl(media.cdn[0], media.hls), dur: media.dur, type: media.type };
    });
    pData = { ...pData, items };
    this.store.dispatch(appStore.setPlaylistDetails(pData));
  }

  handlePlayListUpdate(data) {
    const { playlistDetails, view } = this.store.getState().app;
    let pData = {
      head: data.h, // current running index of playlist
      order: data.o, //complete order of the playlist
      ts: data.t,
      play: false,
    };
    this.store.dispatch(appStore.setCurrentPlayingIndex(data.h));
    //update items map in case media added
    if (data.m && data.m.length > 0) {
      let items = { ...playlistDetails.items };
      data.m.forEach((media) => {
        items[media.id] = { hls: Utils.PrepareSimuliveUrl(media.cdn[0], media.hls), dur: media.dur, type: media.type };
      });
      pData = { ...pData, items };
    }
    if (data.a && data.a === PLAYLIST_ACTION.PLAY && view === APP_VIEW.MAIN) pData = { ...pData, play: true };
    this.store.dispatch(appStore.updatePlaylistDetails(pData));
  }
}
